import React from "react";

export default function VestIcon({
  size = 20,
  className,
  ...rest
}: {
  size?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      {...rest}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.25 3.25H6.0885C6.36475 3.25 6.5885 3.47028 6.5885 3.74224V5.72549C6.5885 5.88301 6.69425 6.02182 6.848 6.06587L9.27825 6.69324C9.432 6.73754 9.53775 6.87611 9.53775 7.03387V16.2622C9.53775 16.5317 9.31575 16.75 9.04225 16.75H7.56075C6.996 16.75 6.4475 16.5639 6.00275 16.2213L4.657 15.1849C4.0845 14.7439 3.75 14.0683 3.75 13.3528V3.74224C3.75 3.47028 3.97375 3.25 4.25 3.25Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.75 3.25H13.9115C13.6353 3.25 13.4115 3.47028 13.4115 3.74224V5.72549C13.4115 5.88301 13.3057 6.02182 13.152 6.06587L10.7217 6.69324C10.568 6.73754 10.4622 6.87611 10.4622 7.03387V16.2575C10.4622 16.5295 10.6862 16.75 10.9625 16.75H12.4117C12.9942 16.75 13.5603 16.558 14.019 16.2046L15.3125 15.2085C15.9043 14.7527 16.25 14.0542 16.25 13.3144V3.74224C16.25 3.47028 16.0262 3.25 15.75 3.25Z"
          fill="black"
        />
      </g>
    </svg>
  );
}

export const VestWideIcon = ({ size = 40 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2309 11.6992H15.43C15.7605 11.6992 16.0281 11.9754 16.0281 12.3163V14.8024C16.0281 14.9999 16.1546 15.1739 16.3385 15.2291L19.2455 16.0155C19.4294 16.0711 19.5559 16.2448 19.5559 16.4425V28.0108C19.5559 28.3486 19.2903 28.6223 18.9632 28.6223H17.1911C16.5155 28.6223 15.8595 28.389 15.3275 27.9596L13.7177 26.6604C13.0329 26.1075 12.6328 25.2606 12.6328 24.3637V12.3163C12.6328 11.9754 12.9005 11.6992 13.2309 11.6992Z"
        fill="#222222"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.6492 11.6992H24.4501C24.1196 11.6992 23.852 11.9754 23.852 12.3163V14.8024C23.852 14.9999 23.7255 15.1739 23.5416 15.2291L20.6346 16.0155C20.4507 16.0711 20.3242 16.2448 20.3242 16.4425V28.0049C20.3242 28.3459 20.5922 28.6223 20.9226 28.6223H22.6561C23.3529 28.6223 24.0299 28.3816 24.5787 27.9386L26.1259 26.69C26.8337 26.1186 27.2473 25.243 27.2473 24.3156V12.3163C27.2473 11.9754 26.9797 11.6992 26.6492 11.6992Z"
        fill="#222222"
      />
    </svg>
  );
};
